import React from 'react';
import { Link } from 'react-router-dom';
import InputText from '../../../components/InputText.jsx';
import TranslationText from '../../../components/Translation/TranslationText.jsx';

export function UsernameInput({ model, errors, businessLogin, onChange }) {
  const hasError = (errors?.username?.length > 0) || (errors?.onLogin?.length > 0);

  return (
    <>
      <div className={`form-field no-margin-bottom ${hasError ? '-has-error' : ''}`}>
        <label htmlFor="email_or_phone" className="form-field__label">
          <TranslationText text="login_page_username_title" />
        </label>
        <InputText
          id="email_or_phone"
          prop="username"
          className="form-field__input"
          value={model?.username || ''}
          onChange={onChange}
          autoComplete="username"
          aria-invalid={hasError}
          aria-describedby={hasError ? "username-error" : undefined}
        />
        {!businessLogin && (
          <Link 
            className="link-button link-button-small" 
            to="/PasswordRecovery/RemindEmail"
            aria-label="Remind me of my email address"
          >
            <TranslationText text="login_page_remind_email_btn" />
          </Link>
        )}
      </div>
      <label 
        id="username-error"
        className="sublabel error-msg show padding-bottom"
        role={hasError ? "alert" : undefined}
      >
        <TranslationText text={errors?.username} />
      </label>
    </>
  );
}